import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';

import { connect } from 'react-redux';
import { getLoaders } from 'selectors';

import { resetErrorMessage } from '../../../actions/internal';
import {
  fetchCards,
  updateCardsMeta,
} from './actions';
import { showBulkSendingModal } from '../../../actions/internal';
import {
  selectCardsLibraryCards,
  selectCardsLibraryMeta,
} from './selectors';
import { isChatEnabled } from '../../../utils/authScopes';
import { getParamsFromQuery } from '../../../utils/query';

import TopNavBar from '../../../containers/nav/TopNavBar';
import SubNavBar from '../../../containers/nav/SubNavBar';
import LibrarySubNav from '../../../components/nav/LibrarySubNav';

import CardsLibraryFilters from './CardsLibraryFilters';
import CardsTable from './CardsTable';

class CardsLibraryPage extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    resetErrorMessage: PropTypes.func.isRequired,
    fetchCards: PropTypes.func.isRequired,
    cards: PropTypes.arrayOf(PropTypes.object).isRequired,
    meta: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    updateCardsMeta: PropTypes.func.isRequired,
    showBulkSendingModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleCardSend = this.handleCardSend.bind(this);
  }

  componentDidMount() {
    this.props.resetErrorMessage();
    this.fetchInitialCards();
  }

  fetchInitialCards() {
    this.props.updateCardsMeta(this.initialParams());
  }

  initialParams() {
    const queryString = this.props.history.location.search;

    if (queryString.length > 0) {
      return getParamsFromQuery(queryString);
    }

    return this.props.meta;
  }

  render() {
    const { cards, meta, isLoading } = this.props;

    return (
      <DocumentTitle title='Sparkler - Cards Library'>
        <div>
          <TopNavBar />
          <SubNavBar />
          <LibrarySubNav />
          <div className="row">
            <div className="column">
              <CardsLibraryFilters isLoading={isLoading} />
              <CardsTable
                cards={cards}
                meta={meta}
                isLoading={isLoading}
                onPageChange={this.handlePageChange}
                allowSend={this.allowSend()}
                onCardSend={this.handleCardSend}
              />
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }

  handlePageChange(page) {
    this.props.updateCardsMeta({
      page: page,
    });
  }

  allowSend() {
    const {auth} = this.props;

    return isChatEnabled(auth);
  }

  handleCardSend(card) {
    this.props.showBulkSendingModal({
      meta: {
        cardIds: [card.id],
      },
    });
  }
}

const mapStateToProps = (state) => {
  return {
    cards: selectCardsLibraryCards(state),
    meta: selectCardsLibraryMeta(state),
    auth: state.auth,
    isLoading: getLoaders(state, ['DASHBOARD_FILTER', 'CARDS']),
  };
};

const mapDispatchToProps = {
  resetErrorMessage,
  fetchCards,
  updateCardsMeta,
  showBulkSendingModal,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CardsLibraryPage);
